import React from 'react';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 16,
  className = '',
}) => {
  return (
    <img
      src="/images/loader.gif"
      alt="Loading..."
      style={{ width: size, height: size }}
      className={className}
    />
  );
};
